import { MAIN_ROLES } from "config";
import { useAuth } from "context/AuthContext"
import { useParams } from "react-router-dom";
import { useGetProjectPermissionQuery } from "store/slices/apis/projectPermissionSlice";

export const useCheckMenuPermission = () => {
    const { user } = useAuth();
    
    // const projectPermission = useGetProjectPermissionQuery({ projectId },
    //     { skip: !projectId });

    // let allPermissions = [];
    // if (projectId !== undefined) {
        const allPermissions = user?.permission?.flatMap(mod => mod?.permissions || []);
    // }

    const hasRoleCheck = () => MAIN_ROLES?.filter(name => user?.rolesName?.includes(name))?.length;

    const hasPermission = (permKey) => {
        if (hasRoleCheck()) return true; 
        
        const permissions = user?.permission?.flatMap(mod => mod?.permissions || []);
        
        return permKey?.some((name) => permissions?.includes(name));
    };
    
    return { allPermissions, hasPermission, hasRoleCheck };

};
